var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDevelopmentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 78.94 78.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-linejoin: round;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-linecap: round;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        fill: none;\n        stroke: #fff;\n      }\n\n      .cls-2, .cls-3 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-4 {\n        fill: #718e56;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 39.47,
    cy: 39.47,
    r: 39.47
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 15.08,
    y: 21.7,
    width: 49.41,
    height: 29.28,
    rx: 6.07,
    ry: 6.07
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "45.83 50.98 48.65 60.91 29.51 60.91 32.33 50.98"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 25.3,
    y1: 35.94,
    x2: 32.94,
    y2: 30.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 32.94,
    y1: 40.96,
    x2: 25.3,
    y2: 35.94
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 54.27,
    y1: 35.94,
    x2: 46.63,
    y2: 30.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 46.63,
    y1: 40.96,
    x2: 54.27,
    y2: 35.94
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 41.87,
    y1: 28.67,
    x2: 36.92,
    y2: 43.2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevelopmentIcon);
export default __webpack_public_path__ + "static/media/development-icon.5933d91c97640026eefbc1c34e7f1f1b.svg";
export { ForwardRef as ReactComponent };